import { DynamicModal } from "src/components/base/components/DynamicModal";
import { createState } from "src/utils/create_zustand_store";
import { Box, Grid } from "@mui/material";
import { EventCard } from "../../../feature/homepageFlow/EventCard";
import { throttleTime } from "src/utils/utils";
import { TPass } from "src/shared/types/globalStotre.types";

export const useViewScheduleModal = createState({
  isOpen: false,
  subscriptionPlan: null as TPass | null,
});

export function ViewScheduleModal() {
  const modalState = useViewScheduleModal();
  const onClose = () => {
    modalState.set({ isOpen: false });
    throttleTime(100, () => {
      modalState.reset();
    });
  };

  return (
    <DynamicModal
      hideTitleIcon
      isOpen={modalState.isOpen}
      title={modalState?.subscriptionPlan?.passTitle}
      description={
        <>
          <Grid container spacing={2}>
            {modalState.subscriptionPlan?.events.map((event, idx) => {
              return (
                <Grid item key={event.eventCode} xs={12}>
                  <EventCard event={event} />
                </Grid>
              );
            })}
          </Grid>
        </>
      }
      onClose={onClose}
      slot={{
        primaryButton: {
          label: "Close",
          onClick: () => onClose(),
        },
        secondaryButton: {
          isHidden: true,
        },
      }}
    />
  );
}
